export class Brands {
    brandId:number;
    brandName:string;

    constructor(brandId:number, brandName:string){
            this.brandId=brandId;
            this.brandName=brandName;
    }
}
